import React, {Fragment } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { formato_rut, isValidParam } from '../../../common/Formatos'

const Conductor = ({ formik, setRutConductorFinal }) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form_implicado } = data_datos_generales
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla } = data_datos_implicado
  
  return (
    <>
      {/* <Container> */}
      <Card className='mt-1 '>
        <Card.Header
          className='mt-0 mb-0'
          as='h6'
          style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}
        >
          {cfg_form_implicado
            ? cfg_form_implicado.cfg_form_implicado[
                'gestcasosrecup-editimpl-title-tabcond'
              ]
            : null}
        </Card.Header>
        <Container>
          {cfg_form_implicado ? (
            <div>
              <Row>
                <Col>
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-rutcond'
                      ]
                    }
                  </Form.Label>{' '}
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['RutConductor']
                        : ""}
                    </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className=' mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-nomcond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['NombreConductor']
                        : ""}
                    </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-dircond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['DireccionConductor']
                        : ""}
                    </Form.Text>
                </Col>

                <Col>
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-emailcond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['EmailConductor']
                        : ""}
                    </Form.Text>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-fonocond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['paisFonoConductor'])
                        ? (datosPantalla.datosPantalla[0]['paisFonoConductor'])+" "+datosPantalla.datosPantalla[0]['FonoConductor']
                        : ""}
                    </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-movilcond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['paisMovilConductor'])
                        ? (datosPantalla.datosPantalla[0]['paisMovilConductor'])+" "+datosPantalla.datosPantalla[0]['MovilConductor']
                        : ""}
                    </Form.Text>
                </Col>

                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-comuncond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['ComunaConductor']
                        : ""}
                    </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-ciudadcond'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? datosPantalla.datosPantalla[0]['CiudadConductor']
                        : ""}
                    </Form.Text>
                </Col>
              </Row>
              <Row>
              <Col>
                  <Form.Label className=' mb-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obscond'] ? cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obscond'] : "Observaciones"}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['obsConductor'])
                        ? (datosPantalla.datosPantalla[0]['obsConductor'])
                        : ""}
                    </Form.Text>
                </Col>
              </Row>
            </div>
          ) : null}
        </Container>
      </Card>
    </>
  )
}

export default Conductor
